import { Builder, IBuilder } from 'builder-pattern';

export interface GameReactionInterface {
  id: number;
  gameUUID: string;
  userID: number;
  emoji: string;
  username: string;
  createdAt: Date;
}

export namespace GameReactionInterface {
  export function builder(
    template?: Partial<GameReactionInterface>
  ): IBuilder<GameReactionInterface> {
    return Builder<GameReactionInterface>(template)
      .createdAt(template?.createdAt ?? new Date());
  }
}